import { useState } from "react";
import { quoteApi } from "@api";
import { ErrorToast } from "src/Components/toasts/ErrorToast";

interface UseQuoteActionsProps {
    onSuccess?: () => void;
}

export const useQuoteActions = ({ onSuccess }: UseQuoteActionsProps = {}) => {
    const [loadingStates, setLoadingStates] = useState<{
        [key: number]: "accept" | "reject" | null;
    }>({});

    const handleAcceptQuote = async (quoteShareId: number) => {
        try {
            setLoadingStates((prev) => ({ ...prev, [quoteShareId]: "accept" }));
            await quoteApi.acceptQuoteInvite(quoteShareId);
            onSuccess?.();
        } catch (error: any) {
            console.error("Failed to accept quote:", error);
            const errorMessage = error?.response?.data?.title || "Failed to accept quote";
            ErrorToast({ Message: errorMessage });
        } finally {
            setLoadingStates((prev) => ({ ...prev, [quoteShareId]: null }));
        }
    };

    const handleRejectQuote = async (quoteShareId: number) => {
        try {
            setLoadingStates((prev) => ({ ...prev, [quoteShareId]: "reject" }));
            await quoteApi.rejectQuoteInvite(quoteShareId);
            onSuccess?.();
        } catch (error: any) {
            console.error("Failed to reject quote:", error);
            const errorMessage = error?.response?.data?.title || "Failed to decline quote";
            ErrorToast({ Message: errorMessage });
        } finally {
            setLoadingStates((prev) => ({ ...prev, [quoteShareId]: null }));
        }
    };

    return {
        loadingStates,
        handleAcceptQuote,
        handleRejectQuote,
    };
};
